import React, { useContext } from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import AppContext from '@context';

function Title() {
  const {
    state: {
      proposals: { pending: proposals },
    },
  } = useContext(AppContext);

  if (!proposals.data.length) {
    return null;
  }

  return (
    <FuelTypography
      size="body-md"
      weight="bold"
      spacingTop={24}
      spacingBottom={24}
    >
      Todas as viagens:
    </FuelTypography>
  );
}

export default Title;
